/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VisibilityEnum = 'CUSTOMER' | 'SUPPORT';

export const VisibilityEnum = {

    CUSTOMER: 'CUSTOMER' as VisibilityEnum,

    SUPPORT: 'SUPPORT' as VisibilityEnum
};

